import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-homefour-featured-services",
    templateUrl: "./homefour-featured-services.component.html",
    styleUrls: ["./homefour-featured-services.component.scss"],
})
export class HomefourFeaturedServicesComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}

    sectionTitle: sectionTitleContent[] = [
        {
            title: "How We Take Your Business From Good To Great",
            paragraphText:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.",
        },
    ];
    singleFeaturedServicesBox: featuredServicesContent[] = [
        {
            icon: "flaticon-analysis",
            title: "What is UDF?",
            paragraphText:
                "UDF is Upstream Data Foundation, an integrated project between UIS-DT and UIT",
            paragraphText1:
                'A priority of the Upstream Technology Strategy: "Urgently build a data foundation to add value across the business"',
            paragraphText2:
                "Overall, enable insight generation across all Upstream capabilities to drive value from data",
            paragraphText3: "",
            linkIcon: "flaticon-right",
            linkText: "Read More",
            link: "services-details",
            class: "UDFDefn",
        },
        {
            icon: "flaticon-structure",
            title: "What problem is UDF solving?",
            paragraphText:
                "Unlock existing data and facilitate the shift from being application-centric to data-centric(interoperability)",
            paragraphText1: "Access to trusted, integrated Upstream data",
            paragraphText2:
                "Scalable execution of data-intensive business workflows, all delivered on modern computing architecture",
            paragraphText3: "",
            linkIcon: "flaticon-right",
            linkText: "Read More",
            link: "services-details",
            class: "UDFCause",
        },
        {
            icon: "flaticon-idea",
            title: "What are the goals of the UDF?",
            paragraphText:
                "Deploy data platform for existing and future use cases, successfully execute defined use cases and demonstrably monetize",
            paragraphText1:
                "Develop and demonstrate clear guidance for data governance and future upstream data roadmap",
            paragraphText2:
                "Work with Digital Foundation Governance Board, actively assist in converging technology and the data ecosystem",
            paragraphText3: "",
            linkIcon: "flaticon-right",
            linkText: "Read More",
            link: "services-details",
            class: "UDFGoals",
        },
    ];
}
class sectionTitleContent {
    title: string;
    paragraphText: string;
}
class featuredServicesContent {
    icon: string;
    title: string;
    paragraphText: string;
    paragraphText1: string;
    paragraphText2: string;
    paragraphText3: string;
    linkIcon: string;
    linkText: string;
    link: string;
    class: string;
}
